<div class="search">
  <div class="search__head">
    <label class="search__field">
      <svg class="search__icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5"></circle>
        <path d="M16 16l4.5 4.5"></path>
      </svg>
      <input #input type="search" enterkeyhint="search" autocomplete="off"
        [placeholder]="'searchMenu' | translate"
        [value]="query" (input)="onQuery(input.value)" (keydown.enter)="input.blur()" />
      <button class="search__clear" type="button" *ngIf="query" (click)="clear()" aria-label="clear">✕</button>
    </label>
    <button class="search__cancel" type="button" (click)="close()">{{ 'cancel' | translate }}</button>
  </div>

  <div class="search__content" *ngIf="results$ | async as results">
    <!-- Пусто: подсказка -->
    <div class="search__hint" *ngIf="!query.trim()">{{ 'searchHint' | translate }}</div>

    <!-- Результаты -->
    <ng-container *ngIf="query.trim() && results.length">
      <div class="search__found">{{ 'found' | translate }} {{ results.length }}</div>
      <div class="product-grid">
        <div class="product-grid-cell" *ngFor="let item of results">
          <app-food-card *ngIf="item.food" [food]="item.food"></app-food-card>
          <app-drink-card *ngIf="item.drink" [drink]="item.drink"></app-drink-card>
        </div>
      </div>
    </ng-container>

    <!-- Ничего не нашлось -->
    <div class="search__empty" *ngIf="query.trim() && !results.length">
      <p>{{ 'nothingFound' | translate }} <b>«{{ query.trim() }}»</b>.<br />{{ 'nothingFoundHint' | translate }}</p>
      <button class="search__all" type="button" (click)="close()">{{ 'allMenu' | translate }}</button>
    </div>
  </div>
</div>
